const api = {
	storeDetail: '/store/detail',                           // 查询店铺详情
	mallDetail: '/mall/detail',												 // 查看商城详情
	getDetailByManager: '/store/getDetailByManager',   // 商家查询店铺详情
	listStoreCategories: '/store/listStoreCategories', //获取店铺类型列表
	updateStore: '/store/updateStore',                 // 更新店铺信息
	auditDetail: '/store/auditDetail',                 // 店铺审核状态
	listPublishedCommodityNames: '/commodity/listPublishedCommodityNames', //商品名称
	downloadStoreCollectionCode: '/store/downloadStoreCollectionCode',  // 下载店铺二维码
	downloadStoreQrcode: '/store/downloadStoreQrcode', // 店铺推广码下载
	listBuildingsByCommunityId: '/address/listBuildingsByCommunityId', //获取楼栋信息
};

const routes = {
	'/shop-manage': '基础信息',
	'/shop-manage/edit': '门店信息编辑'
};

export {
	api,
	routes,
};
